import * as React from 'react'
import { createPortal } from 'react-dom'
import { useAidaOverlayStore } from '../../stores/overlay-store'
import { useAidaPipStore } from '../../stores/picture-in-picture-store'
import {
  AidaChatPresentationContext,
  chatPresentationForOverlayMode,
} from '../../utils/chat-presentation'
import { useReparentedNode } from '../../hooks/use-reparented-node'
import { AidaPaneActiveContext } from '../../utils/pane-active'

const AidaChat = React.lazy(() =>
  import('../layout/aida-chat').then(module => ({ default: module.AidaChat })),
)

export const ParkedChat = React.memo(function ParkedChat({
  open,
  chatHost,
}: {
  open: boolean
  chatHost: HTMLDivElement
}) {
  const mode = useAidaOverlayStore(state => state.mode)
  const pipActive = useAidaPipStore(state => state.active)
  const presentation = pipActive ? 'float' : chatPresentationForOverlayMode(mode)
  const mount = useReparentedNode(chatHost)

  return createPortal(
    <AidaPaneActiveContext.Provider value={open}>
      <AidaChatPresentationContext.Provider value={presentation}>
        <React.Suspense fallback={null}>
          <AidaChat />
        </React.Suspense>
      </AidaChatPresentationContext.Provider>
    </AidaPaneActiveContext.Provider>,
    mount,
  )
})
